import React from "react";
import Breadcrumbs from "helpers/breadcrumbs";

const PatioBreadcrumbs = ({ data: { links } }) => (
    <div className="bg-white container max-w-3xl">
        <Breadcrumbs links={links} />
    </div>
);

export default PatioBreadcrumbs;
